const SVG_DATA_URL_PREFIX = 'data:image/svg+xml';
const BASE64_MARKER = ';base64';

function encodeUtf8AsBase64(value: string): string {
	const bytes = new TextEncoder().encode(value);
	let binary = '';

	for (const byte of bytes) {
		binary += String.fromCharCode(byte);
	}

	return btoa(binary);
}

export function normalizeSvgAssetUrl(assetUrl: string): string {
	if (!assetUrl.startsWith(SVG_DATA_URL_PREFIX) || assetUrl.includes(BASE64_MARKER)) {
		return assetUrl;
	}

	const dataSeparatorIndex = assetUrl.indexOf(',');

	if (dataSeparatorIndex === -1) {
		return assetUrl;
	}

	const metadata = assetUrl.slice(0, dataSeparatorIndex);
	const svg = decodeURIComponent(assetUrl.slice(dataSeparatorIndex + 1));

	return `${metadata}${BASE64_MARKER},${encodeUtf8AsBase64(svg)}`;
}
